module.exports = __webpack_public_path__ + "img/sixpackcarrier01.cc4a71f9.jpg";